import * as React from "react";
import Api from "../../api";
import { Text } from "../../models";

const MAX_LENGTH = 20000;

const TextForm: React.FC<{ onTextCreated: (text: Text) => void }> = ({
  onTextCreated,
}) => {
  const [text, setText] = React.useState<string>("");
  const [saving, setSaving] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    if (!text) {
      return;
    }
    setSaving(true);
    try {
      const res = await Api.texts.create("text", text);
      if ("errors" in res) {
        setError(res.errors.join(", "));
        return;
      }
      onTextCreated(res);
    } catch (err) {
      console.error("Error ocurred while creating a text: ", err);
      setError("Something went wrong");
      return;
    } finally {
      setSaving(false);
    }
  };

  const charLeft = MAX_LENGTH - text.length;
  const isValid = charLeft >= 0;
  const info = charLeft > 0 ? `${charLeft} characters left` : "Too long";

  return (
    <div className="text-form">
      <form onSubmit={handleSubmit}>
        <div className="text-wrapper">
          <textarea
            className="text-input"
            placeholder="Enter text here"
            value={text}
            onChange={(e) => setText(e.target.value)}
            autoFocus
          ></textarea>
        </div>
        <div className="btn-wrapper">
          <button
            className="btn btn-primary"
            type="submit"
            disabled={!text || saving || !isValid}
          >
            CREATE ANKI CARDS
          </button>
          <div className="info">{info && info}</div>
          <div className="error">{error && error}</div>
        </div>
      </form>
    </div>
  );
};

export default TextForm;
